import { LocalizationProvider } from "@mui/lab";
import { InputAdornment, Popover, TextField } from "@mui/material";
import styles from "./styles";
import CommonUtil from "@utils/utility";
import AdapterMoment from "@mui/lab/AdapterMoment";
import DateRangeIcon from "@mui/icons-material/DateRange";
import { DateRangePicker } from "mui-daterange-picker";
import { useState } from "react";
import useStyles from "@hooks/useStyle";
import { MvDateRangePickerPropsInterface } from "@mv-components/types";

const DateRangeComp = (props: MvDateRangePickerPropsInterface) => {
	const { onChange, itemKey, value, className, placeholder } = props;
	const { classes, cx } = useStyles(styles) as any;

	const onKeyDown = (e: any) => {
		e.preventDefault();
	};

	const getValue = (startDate?: Date, endDate?: Date) => {
		const start = startDate?.toLocaleDateString();
		const end = endDate?.toLocaleDateString();
		return startDate ?? endDate
			? `${start === "" ? "DD/MM/YYYY" : start} - ${end === "" ? "DD/MM/YYYY" : end}`
			: "";
	};

	const [open, setOpen] = useState(false);

	const toggle = () => setOpen(!open);

	const date = new Date();
	const last3Days = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 2);
	const lastWeek = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 6);
	const firstDateOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
	const firstDateOfLastMonth = new Date(date.getFullYear(), date.getMonth(), 1);
	firstDateOfLastMonth.setMonth(firstDateOfLastMonth.getMonth() - 1);

	const definedRanges = [
		{ startDate: last3Days, endDate: date, label: "Last 3 days" },
		{ startDate: lastWeek, endDate: date, label: "Last week" },
		{ startDate: firstDateOfMonth, endDate: date, label: "This month" },
	];

	const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

	const handleClick = (event: any) => {
		setOpen(true);
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const id = open ? "simple-popover" : undefined;

	return (
		<LocalizationProvider dateAdapter={AdapterMoment}>
			<TextField
				className={cx(classes.root, className ? classes[className] : null)}
				onClick={handleClick}
				value={getValue(value.startDate, value.endDate)}
				placeholder={placeholder}
				onKeyDown={onKeyDown}
				autoComplete="off"
				helperText={CommonUtil.getHelperTxt(props)}
				error={CommonUtil.isError(props)}
				variant="outlined"
				size="small"
				InputProps={{
					endAdornment: (
						<InputAdornment position="end">
							<DateRangeIcon />
						</InputAdornment>
					),
				}}
			/>
			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "top",
					horizontal: "left",
				}}
			>
				<DateRangePicker
					closeOnClickOutside={true}
					initialDateRange={value}
					wrapperClassName={classes.custom}
					definedRanges={definedRanges}
					open={true}
					// maxDate={date}
					toggle={toggle}
					onChange={(value) => {
						onChange({ itemKey, value });
					}}
				/>
			</Popover>
		</LocalizationProvider>
	);
};

export default DateRangeComp;
